export enum ValidationErrors {
    ERROR_NOT_ENOUGH_ADULT_TRAVELLERS = 'ERROR_NOT_ENOUGH_ADULT_TRAVELLERS',
    ERROR_TOO_MANY_ADULT_TRAVELLERS = 'ERROR_NOT_ENOUGH_ADULT_TRAVELLERS',
    ERROR_NOT_ENOUGH_CHILD_TRAVELLERS = 'ERROR_NOT_ENOUGH_CHILD_TRAVELLERS',
    ERROR_TOO_MANY_CHILD_TRAVELLERS = 'ERROR_TOO_MANY_CHILD_TRAVELLERS',
}
